import React from 'react';
import { BsStars } from 'react-icons/bs';
import Logo from 'components/template/Logo';

const LoadingSkeleton = ({ aspectRatio }) => {
    const getAspectRatioClass = (ratio) => {
        switch (ratio) {
            case '1:1': return 'aspect-square';
            case '16:9': return 'aspect-video';
            case '9:16': return 'aspect-[9/16]';
            case '4:3': return 'aspect-[4/3]';
            case '3:4': return 'aspect-[3/4]';
            case '3:2': return 'aspect-[3/2]';
            case '2:3': return 'aspect-[2/3]';
            default: return 'aspect-square';
        }
    };

    return (
        <div className="flex justify-start">
            <div className="flex gap-3 max-w-[70%] w-full">
                {/* AI Avatar */}
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-primary-800 to-primary-900 flex items-center justify-center overflow-hidden">
                    <Logo 
                        type="streamline"
                        className="w-5 h-5"
                        imgClass="w-full h-full object-contain"
                    />
                </div>

                {/* Loading Content */}
                <div className="flex flex-col gap-3 w-full">
                    {/* Loading Skeleton Image - Made larger to match actual image size */}
                    <div className="flex justify-center w-full">
                        <div className="relative group w-full max-w-[512px]">
                            <div className={`w-full bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 rounded-xl overflow-hidden ${getAspectRatioClass(aspectRatio)}`}>
                                {/* Shimmer Effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer transform -skew-x-12"></div>
                            </div>
                            {/* Loading text */}
                            <div className="mt-2 flex items-center justify-center gap-2 !h-0 overflow-hidden invisible w-full">
                                <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                                <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                                <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                                <span className="text-sm text-gray-500 dark:text-gray-400 ml-2">Generating image...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSkeleton; 